import { createTranslationRef } from '@backstage/core-plugin-api/alpha';

const kubernetesTranslationRef = createTranslationRef({
  id: "kubernetes",
  messages: {
    kubernetesContentPage: {
      permissionAlert: {
        title: "Permission required",
        message: "To view Kubernetes objects, contact your portal administrator to give you the 'kubernetes.clusters.read' and 'kubernetes.resources.read' permission."
      }
    }
  }
});

export { kubernetesTranslationRef };
//# sourceMappingURL=translation.esm.js.map
